import React, { useEffect } from "react";
import {
  BrowserRouter,
  Switch,
  Route,
  Routes,
  useNavigate,
} from "react-router-dom";
import Login from "../Pages/Login";
import ProtectedRoute from "../utils/ProtectedRoute";
import { Addroutes, Editroutes, routes } from "./RoutesName";

const AppRoutes = (props) => {
  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login />} />
          {/* <Routes> */}
          {routes.map((route, ind) => {
            return (
              <Route
                path={"/dashboard/" + route.name.toLocaleLowerCase()}
                element={<ProtectedRoute> {route.component} </ProtectedRoute>}
              />
            );
          })}

          {/* <Routes> */}
          {Editroutes.map((route, ind) => {
            return (
              <Route
                path={"/dashboard/" + route.name.toLocaleLowerCase()}
                element={<ProtectedRoute> {route.component} </ProtectedRoute>}
              />
            );
          })}

          {/* <Routes> */}
          {Addroutes.map((route, ind) => {
            return (
              <Route
                path={"/dashboard/" + route.name.toLocaleLowerCase()}
                element={<ProtectedRoute> {route.component} </ProtectedRoute>}
              />
            );
          })}
        </Routes>
      </BrowserRouter>
    </div>
  );
};

export default AppRoutes;
